import {Component, OnDestroy, OnInit} from '@angular/core';
import {HelperService} from '../../../services/helperService';


@Component({
	selector: 'tig-starter',
	templateUrl: 'starter.template.html'
})
export class StarterComponent implements OnDestroy, OnInit
{
	
	
	/**
	 * Attributes
	 */
	OBJ_navbar: any;
	
	
	/**
	 * Function > constructor
	 */
	public constructor()
	{
		// get navbar element
		this.OBJ_navbar = document.querySelector('nav.navbar');
	} // end function constructor
	
	
	/**
	 * Function > ngOnInit
	 * @returns {any}
	 */
	public ngOnInit(): any
	{
		// this.OBJ_navbar.className += ' white-bg';
	} // end function ngOnInit
	
	
	/**
	 * Function > ngOnDestroy
	 * @returns {any}
	 */
	public ngOnDestroy(): any
	{
		this.OBJ_navbar.classList.remove('white-bg');
	} // end function ngOnDestroy
	
	
} // end class StarterComponent